// Wrap everything in an IIFE to avoid global scope pollution
(function() {
  // Create and inject the SVG gradient definitions only once
  function createAndInjectGradients() {
    if (document.getElementById('okendo-gradient-defs')) {
      return;
    }
    
    const svgGradient = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    svgGradient.setAttribute('id', 'okendo-gradient-defs');
    svgGradient.setAttribute('width', '0');
    svgGradient.setAttribute('height', '0');
    svgGradient.style.position = 'absolute';
    svgGradient.style.visibility = 'hidden';
    
    const defs = document.createElementNS('http://www.w3.org/2000/svg', 'defs');
    
    // Fill gradient (top to bottom: yellow to orange)
    const fillGradient = document.createElementNS('http://www.w3.org/2000/svg', 'linearGradient');
    fillGradient.setAttribute('id', 'okendo-star-fill-gradient');
    fillGradient.setAttribute('x1', '0%');
    fillGradient.setAttribute('y1', '0%');
    fillGradient.setAttribute('x2', '0%');
    fillGradient.setAttribute('y2', '100%');
    
    // Stroke gradient (top to bottom: yellow to orange)
    const strokeGradient = document.createElementNS('http://www.w3.org/2000/svg', 'linearGradient');
    strokeGradient.setAttribute('id', 'okendo-star-stroke-gradient');
    strokeGradient.setAttribute('x1', '0%');
    strokeGradient.setAttribute('y1', '0%');
    strokeGradient.setAttribute('x2', '0%');
    strokeGradient.setAttribute('y2', '100%');
    
    const fillStop1 = document.createElementNS('http://www.w3.org/2000/svg', 'stop');
    fillStop1.setAttribute('offset', '0%');
    fillStop1.setAttribute('stop-color', '#FFCC00');
    
    const fillStop2 = document.createElementNS('http://www.w3.org/2000/svg', 'stop');
    fillStop2.setAttribute('offset', '100%');
    fillStop2.setAttribute('stop-color', '#FF9900');
    
    const strokeStop1 = document.createElementNS('http://www.w3.org/2000/svg', 'stop');
    strokeStop1.setAttribute('offset', '0%');
    strokeStop1.setAttribute('stop-color', '#FFCC00');
    
    const strokeStop2 = document.createElementNS('http://www.w3.org/2000/svg', 'stop');
    strokeStop2.setAttribute('offset', '100%');
    strokeStop2.setAttribute('stop-color', '#FF9900');
    
    fillGradient.appendChild(fillStop1);
    fillGradient.appendChild(fillStop2);
    strokeGradient.appendChild(strokeStop1);
    strokeGradient.appendChild(strokeStop2);
    defs.appendChild(fillGradient);
    defs.appendChild(strokeGradient);
    svgGradient.appendChild(defs);
    document.body.appendChild(svgGradient);
  }
  
  // Apply gradient styles to star symbol definitions
  function applyStylesToStarSymbols() {
    let modified = false;
    
    const filledSymbols = document.querySelectorAll('symbol[id="oke-star-filled"]');
    filledSymbols.forEach(symbol => {
      if (!symbol.hasAttribute('data-gradient-applied')) {
        const paths = symbol.querySelectorAll('path');
        paths.forEach(path => {
          path.setAttribute('fill', 'url(#okendo-star-fill-gradient)');
          path.removeAttribute('fill-opacity');
        });
        symbol.setAttribute('data-gradient-applied', 'true');
        modified = true;
      }
    });
    
    const emptySymbols = document.querySelectorAll('symbol[id="oke-star-empty"]');
    emptySymbols.forEach(symbol => {
      if (!symbol.hasAttribute('data-gradient-applied')) {
        const paths = symbol.querySelectorAll('path');
        paths.forEach(path => {
          path.setAttribute('fill', 'transparent');
          path.setAttribute('stroke', 'url(#okendo-star-stroke-gradient)');
          path.setAttribute('stroke-width', '1');
          path.removeAttribute('fill-opacity');
        });
        symbol.setAttribute('data-gradient-applied', 'true');
        modified = true;
      }
    });
    
    return modified;
  }
  
  // Apply gradient styles to star instances
  function applyStylesToStarInstances() {
    document.querySelectorAll('use[href="#oke-star-filled"]').forEach(use => {
      if (!use.hasAttribute('data-gradient-applied')) {
        use.setAttribute('fill', 'url(#okendo-star-fill-gradient)');
        use.removeAttribute('fill-opacity');
        use.setAttribute('data-gradient-applied', 'true');
      }
    });
    
    document.querySelectorAll('use[href="#oke-star-empty"]').forEach(use => {
      if (!use.hasAttribute('data-gradient-applied')) {
        use.setAttribute('fill', 'transparent');
        use.setAttribute('stroke', 'url(#okendo-star-stroke-gradient)');
        use.setAttribute('stroke-width', '1');
        use.removeAttribute('fill-opacity');
        use.setAttribute('data-gradient-applied', 'true');
      }
    });
  }
  
  // Add CSS overrides for star styling
  function addStyleOverrides() {
    if (document.getElementById('okendo-star-styles')) {
      return;
    }
    
    const styleEl = document.createElement('style');
    styleEl.id = 'okendo-star-styles';
    styleEl.textContent = `
      use[href="#oke-star-filled"] {
        fill: url(#okendo-star-fill-gradient) !important;
      }
      
      use[href="#oke-star-empty"] {
        fill: transparent !important;
        stroke: url(#okendo-star-stroke-gradient) !important;
        stroke-width: 1px !important;
      }
      
      .oke-stars-foreground svg use {
        fill: url(#okendo-star-fill-gradient) !important;
      }
      
      .oke-stars-background svg use {
        fill: transparent !important;
        stroke: url(#okendo-star-stroke-gradient) !important;
        stroke-width: 1px !important;
      }
    `;
    document.head.appendChild(styleEl);
  }
  
  // Hide widget if fewer than 5 reviews
  function hideWidgetIfInsufficientReviews() {
    const reviewWidgets = document.querySelectorAll('[data-oke-reviews-product-id]');
    
    reviewWidgets.forEach(widget => {
      const metadataScript = widget.querySelector('script[data-oke-metafield-data]');
      
      if (metadataScript) {
        try {
          const data = JSON.parse(metadataScript.textContent);
          
          if (data.reviewAggregate && data.reviewAggregate.ratingAndReviewCount < 5) {
            const blockWrapper = widget.closest('.shopify-block');
            if (blockWrapper) {
              blockWrapper.style.display = 'none';
            }
          }
        } catch (e) {
          console.error('Error parsing Okendo data:', e);
        }
      }
    });
  }
  
  // Monitor DOM for dynamic content changes
  function setupContinuousMonitoring() {
    applyStylesToStarSymbols();
    applyStylesToStarInstances();
    hideWidgetIfInsufficientReviews();
    
    const observer = new MutationObserver(function() {
      applyStylesToStarSymbols();
      applyStylesToStarInstances();
      hideWidgetIfInsufficientReviews();
    });
    
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
    
    const intervalCheck = setInterval(function() {
      applyStylesToStarSymbols();
      applyStylesToStarInstances();
      hideWidgetIfInsufficientReviews();
    }, 1000);
    
    setTimeout(function() {
      clearInterval(intervalCheck);
    }, 30000);
  }
  
  // Initialize all functionality
  function init() {
    createAndInjectGradients();
    addStyleOverrides();
    setupContinuousMonitoring();
    
    if (window.okeReviewsWidgetOnLoad) {
      const originalCallback = window.okeReviewsWidgetOnLoad;
      window.okeReviewsWidgetOnLoad = function() {
        originalCallback.apply(this, arguments);
        setTimeout(function() {
          applyStylesToStarSymbols();
          applyStylesToStarInstances();
          hideWidgetIfInsufficientReviews();
        }, 100);
      };
    }
  }
  
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();